import { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";
import { useTranslation } from "react-i18next";

function BrowserDisclaimer(): JSX.Element {
  const { t } = useTranslation();
  const [open, setOpen] = useState<boolean>(false);

  useEffect(() => {
    // Check if the user is not using Chrome
    const userAgent = navigator.userAgent;
    const isChrome = /Chrome|CriOS/i.test(userAgent);
    setOpen(!isChrome);
  }, []);

  return (
    <Box
      display={open ? "flex" : "none"}
      justifyContent="center"
      alignContent="center"
      bgcolor="warning.main"
      p={1}
      className="browser-disclaimer"
      sx={{ width: "100%", paddingX: { xs: 2, md: 5, xl: 12 } }}
    >
      <ReportProblemOutlinedIcon />
      <Typography variant="body2" fontSize="16px" sx={{ paddingLeft: 1 }}>
        {t("homepage.browserDisclaimerText")}
      </Typography>
    </Box>
  );
}

export default BrowserDisclaimer;
